import styled from 'styled-components';
import CustomCard from '@components/CustomCard';
import { Row } from 'antd';

export const CardContainer = styled(CustomCard)`
  height: 100%;

  span {
    color: ${({ theme }) => theme.colors.text1};
  }
`;

export const CardContainerFiltersRow = styled(Row)`
  margin-bottom: 26px;
  padding: 8px;
  background: ${({ theme }) => theme.colors.background1};
  border-radius: ${({ theme }) => theme.shapes.borderRadius};
  border: 1px solid ${({ theme }) => theme.colors.border};
`;

export const CardActiveSimcards = styled.p`
  font-weight: normal;
  font-size: 0.9rem;
  margin: 0;
  strong {
    font-size: 0.95rem;
    color: ${({ theme }) => theme.colors.primary};
  }
`;
